export default <T>(
    elements: T[],
    mobileColumnsNumber: number,
    desktopColumnsNumber?: number
) => {
    const desktopColumns = desktopColumnsNumber || mobileColumnsNumber;

    const splitArray = (arr: T[], numberOfChunks: number) => {
        const columnSize = Math.ceil(arr.length / numberOfChunks);
        return Array.from({ length: numberOfChunks }).map((_column, index) => {
            return arr.slice(
                index * columnSize,
                columnSize + index * columnSize
            );
        });
    };

    return [
        splitArray(elements, mobileColumnsNumber),
        splitArray(elements, desktopColumns),
    ];
};
